export const locale = {
  lang: 'nl',
  data: {
    'LEADER_GO': {
      'SECCION_SELECT_LEADER':{
        'TEX_CARGA_INFO': 'Leiders laden',
        'TEX_FILT_INFO': 'Filtreren van leiders',
        'TEX_TITL_TAB1': 'Selecteren leiders',
        'TEX_TITL_TAB2': 'Voorbeeld geselecteerde leiders',
        'TEX_TITL_TAB2_1':'Líderes guardados',
        'TEX_INDIC_1': '*Selecteer leiders om toe te passen',
        'TEX_INDIC_BUSQ': 'Geef naam, e-mail of gebied in',
        'TEX_BTN_FILT': 'Filter',
        'TH_1': 'Naam leider',
        'TH_2': 'E-mail',
        'TH_3':'Gebied',
        'TH_4':'Genero',
        'TH_5':'Año',
        'TH_6':'Tipo de trabajo',
        'TH_7':'CGO gebruikersstatus',
        'TH_EMA_LOCA': 'Plaats',
        'TH_EMA_SEND': 'Mails verzonden',
        'TH_PUEST_LEAD':'Post',
        'STATUS_LOGIN_CGO':{
        'false':'Inactief',
        'true':'Actief',
        'undefined':'Inactief',
        },
        'MODAL_ACTU_BAN_UNI': 'Geselecteerde leider toevoegen',
        'MODAL_ACTU_BAN_MUL': 'Toevoegen geselecteerde leiders',
        'WARNI_NO_SELEC': 'Kan de stap nog niet voltooien, aangezien er geen leider is geselecteerd',
        'COMFI_COMP_PAS':'Weet u zeker dat u de stap voor het selecteren van leiders hebt voltooid?',
        'BTN_CONFI_OK':'OK',
        'BTN_CONFI_YES':'Ja',
        'BTN_CONFI_NO':'Nee',
        'MODAL_CONFI_GUAR_LEA':'¿Está seguro de guardar los líderes seleccionados?',
        'BTN_GUAR_LEA':'Guardar líderes seleccionados',
        'BTN_ACT_LEA':'Actualizar líderes seleccionados',
        'MSN_INGR_COD':'<span> Om uitnodigings-e-mails te verzenden, voert u de code in het rood in in het tekstvak ',
        'MSN_INGR_COD2':'</span>',
        'MODAL_CONFI_SEND_MAIL': 'Weet u zeker dat u de e-mails wilt verzenden?',
        'MODAL_CONFI_ACTIV_USER_CGO':'Weet je zeker dat je de gebruiker moet activeren?',
        'MODAL_CONFI_DESACTIV_USER_CGO':'Weet u zeker dat u de gebruiker wilt deactiveren?',
        'MSN_INGR_COD_ACTI_USER':'<span> Om de gebruiker te activeren/deactiveren, voert u de code in het rood in het tekstvak in ',
        'MODAL_ERR_COD': 'De geplaatste tekst komt niet overeen',
        'WARNI_NO_SELEC_LEA':'Om e-mails te kunnen verzenden, moet u ten minste één leider selecteren',
        'BTN_SEND_MAIL':'Mails verzenden',
        'BTN_CONFI_CONFIRMAR':'Bevestigen',
        'BTN_CONFI_CANCELAR':'Annuleren',
        'MOD_INFO_SEN_EMA':'E-mails versturen...',
        'SUCCE_SEN_EMA':'Ze zijn correct verzonden',
        'NO_LEAD_PRODUCT_ASO':'Het bijbehorende certificaat voor dit product bevat geen loodgebruikers.',
        'MOD_ACTI_USE_CGO':'Bijwerken gebruikersstatus',
        'SUCCE_UPDA_STA_USE':'Succesvol bijgewerkt',
      },
      'SECCION_PROGRAMACION':{
        'MODAL_CONFI_COMPL':'Weet je zeker dat je de mail editor stap hebt voltooid? ',
      'FECHAS':{
        'TITULO': 'Selecteer datums',
        'BTN_TEXT': 'Selecteer data',
        'INSTRUC_TEXT': 'Selecteer en registreer de verschillende data die beschikbaar zijn om te configureren',
      },
      'CORREOS':{
        'TITULO': 'Communicatieberichten',
        'BTN_TEXT': 'Communicatieberichten bekijken',
        'INSTRUC_TEXT': 'De te verzenden communicatieberichten bekijken',
       'TIPOS_CORREO':{
         'TIPO1_INVITA':{
           'TITULO': 'Uitnodigingsbericht',
              'DESCRIP': 'Dit is het bericht dat naar de leiders wordt gestuurd op de dag dat de uitnodiging wordt gelanceerd',
         },
         'TIPO2_RECOR_NO_INI':{
           'TITULO': 'Bericht aan leiders die niet zijn gestart',
               'DESCRIP': 'Dit is het herinneringsbericht dat wordt verstuurd naar leiders die nog niet zijn gestart',
         },
         'TIPO3_RECOR_NO_FINA':{
           'TITULO':'Bericht aan de leiders die nog niet zijn begonnen',
              'DESCRIP': 'Dit is het herinneringsbericht dat wordt verstuurd naar de leiders die al met hun enquête zijn begonnen maar nog niet klaar zijn.',
         },
       }
      },
      'MODAL_ACCIO':{
    'TIPO_ACCIO_FECH':{
       'TITU_TEXT1':'Selecteer elk van de beschikbare data om te configureren',
      }
    },
    'ETIQ':{
      'tag_name': 'De naam van de leider',
          'tag_codeCoupon': 'De couponcode',
          'tag_productoId':'Het product-id',
          'tag_nameCourse':'De naam van de cursus',
    }
    },
    'TIP_EMAI': {
      'lanzamiento': 'Startdatum uitnodiging',
        'aviso1': 'Pre-release (eerste bericht vóór lancering van de enquête)',
        'aviso2': 'Voorlancering (tweede bericht voor lancering van de enquête)',
        'cierre': 'Afsluitingsdatum',
        'recordatorio1': 'Datum van verzending van de herinnering aan degenen die nog niet zijn begonnen',
        'recordatorio2': 'Datum van verzending van de herinnering aan degenen die nog niet klaar zijn',
    },
    'SECCION_CONFIRM':{
      'BTN_CONFIRM_ENVIO':'Bevestig mailing',
      'BTN_ENVIO_CONFIRM':'De mailing is bevestigd',
      'MODAL_COMPL_CONF':'Weet u zeker dat u de mailingbevestigingsstap hebt voltooid?',
      'MODAL_WARNIN_CONF':'Om de stap te voltooien moet u de verzending van de mails bevestigen.',
    },
    'SECCI_AVANCE':{
      'CARDS':{
        'PASO_1':{
          'TITULO': 'Advancement',
          'DESCRIP': 'Leiders promotie',
          'BTN_1': 'Ga naar telpoort',
          'BTN_2':'',
        },
        'PASO_2':{
          'TITULO': 'Herinnering',
          'DESCRIP': 'Herinnering aan leiders die het proces nog niet hebben gestart of afgerond',
          'BTN_1': 'Herinnering',
          'BTN_2':'',
        }
      }
    },
    },
    'ACTION_GO':{
      'COLUMNAS':{
          'NameUser':'Naam',
          'email':'Mail',
          'Area':'Gebied',
          'JobTitle':'Post',
          'Localidad':'Plaats',
          'NumberOfEmails':'Verzonden post',
          'Age':'Jaar',
          'Gneration':'Geslacht',
          'IdUser':'Gebruikers-id',
          'SurveyID':'Enquête-id',
          'keyUserlogin':'Wachtwoord',
          'Pass_cgo':'Wachtwoord',
      }
    }
  }
};
